import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=86d882f0&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=86d882f0&prod&lang=scss&scoped=true"
import style1 from "./messageList.vue?vue&type=style&index=1&id=86d882f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d882f0",
  null
  
)

export default component.exports